import {getFirstFulfilledInSequence} from '@yourcoach/async-utils';

import type {
  CoreClientConferencesReadParams,
  CoreCoachConferencesReadParams,
} from '../../../api/types/core/methods';
import type {AsyncStrategy, BaseConfig, Batch} from '../utils';

import {conferenceStore} from '../../../api/conference';
import {isIamCoach} from '../../../utils/entity/isIamCoach';

export {
  conferenceFetch,
  /** @public */
  conferenceFetchBatch,
};

type Config = BaseConfig<
  CoreClientConferencesReadParams | CoreCoachConferencesReadParams
>;

const strategy: AsyncStrategy = async (roles, config) => {
  return isIamCoach()
    ? getFirstFulfilledInSequence([roles.coach, roles.client], config)
    : roles.client(config);
};

async function conferenceFetch(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

conferenceFetch.asClient = asClient;
conferenceFetch.asCoach = asCoach;

async function conferenceFetchBatch(config: Batch<Config>) {
  return strategy({client: asClientBatch, coach: asCoachBatch}, config);
}

conferenceFetchBatch.asClient = asClientBatch;
conferenceFetchBatch.asCoach = asCoachBatch;

async function asClient(config: Config) {
  return conferenceStore.client.fetch(config.params, config.options);
}

async function asClientBatch(config: Batch<Config>) {
  return conferenceStore.client.fetchBatch(config.params, config.options);
}

async function asCoach(config: Config) {
  return conferenceStore.coach.fetch(config.params, config.options);
}

async function asCoachBatch(config: Batch<Config>) {
  return conferenceStore.coach.fetchBatch(config.params, config.options);
}
